import { FieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/utils";
import alertCircle from "@/assets/images/alert-circle.svg";

type ErrorMessageProps = {
  id?: string | undefined;
  isHtml?: Boolean | undefined;
  error?: FieldError | undefined;
  acceptTermsAndConditions?: FieldError | undefined;
  errorString?: string | undefined;
  alignCenter?: Boolean | undefined;
};

export default function ErrorMessage({
  alignCenter = true,
  isHtml = false,
  errorString,
  ...props
}: ErrorMessageProps) {

  if (!props.error || !errorString || !props.acceptTermsAndConditions) {
    return null;
  }

  const { t } = useTranslation();

  const renderErrorContent = (message: string) => (
    <div id={props.id} className="text-[var(--redCredentials)] text-xs ml-2 mt-2" dangerouslySetInnerHTML={{ __html: message }} />
  );

  return (
    <div className={cn("mt-2", alignCenter ? "justify-center" : "")}>
      {props.error && (
        <div className="inline-flex w-full errorDiv">
          <img src={alertCircle} alt="" className="mt-2 h-8 w-8" />
          {isHtml ? renderErrorContent(props.error.message || "") :
            <span
              aria-live={props.error ? "assertive" : "off"}
              aria-hidden={!props.error}
              aria-errormessage="tá mal"
              role="alert"
              id={props.id}
              className="text-[var(--redCredentials)] text-xs ml-2 mt-2">
              {props.error.message}
            </span>
          }
        </div>
      )}

      {errorString && (
        <div className="inline-flex w-full errorDiv">
          <img src={alertCircle} alt="" className="mt-2 h-8 w-8" />
          {renderErrorContent(errorString)}
        </div>
      )}

      {props.acceptTermsAndConditions && (
        <div className="inline-flex w-full errorDiv">
          <img src={alertCircle} alt="" className="mt-2 h-8 w-8" />
          {renderErrorContent(t("common.validate_password"))}
        </div>
      )}
    </div>
  );
}; 
